import { render, staticRenderFns } from "./customer-attributes.vue?vue&type=template&id=110b5060"
import script from "./customer-attributes.vue?vue&type=script&lang=js"
export * from "./customer-attributes.vue?vue&type=script&lang=js"
import style0 from "./customer-attributes.vue?vue&type=style&index=0&id=110b5060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports